module.exports = __webpack_public_path__ + "static/media/bg_top.9c06d964.png";